import React from 'react'
import './BreadCrum.css'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

function BreadCrum(param) {

    const product = param.product
    console.log(product.category);

    return (
        <div className='breadcrum'>
             Home <KeyboardArrowRightIcon /> {product.category} <KeyboardArrowRightIcon /> {product.type} <KeyboardArrowRightIcon /> {product.name} [{product.brand}]
        </div>
    )
}

export default BreadCrum